import React, { PropsWithChildren, ReactNode } from "react";
import {
  Dialog as MuiDialog,
  DialogTitle,
  IconButton,
  DialogContent,
  DialogProps,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

interface Dialog {
  isOpen: boolean;
  onClose?: () => void;
  title?: ReactNode;
  dialogProps?: Omit<DialogProps, "open" | "onClose">;
}

const Dialog: React.FC<PropsWithChildren<Dialog>> = ({
  isOpen,
  onClose,
  title,
  children,
  dialogProps = {},
}) => {
  const handleClose = (): void => {
    onClose?.();
  };

  return (
    <MuiDialog open={isOpen} sx={{ p: 4 }} {...dialogProps}>
      {title ? <DialogTitle>{title}</DialogTitle> : null}
      {onClose && (
        <IconButton
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 16,
            top: 16,
          }}
        >
          <CloseIcon />
        </IconButton>
      )}
      {children ? <DialogContent>{children}</DialogContent> : null}
    </MuiDialog>
  );
};

export default Dialog;
